import React, { Component } from 'react';
import { Icon, Header } from 'semantic-ui-react';
import styled from 'styled-components';

import { colors } from 'utils/colors';

class RetirementCard extends Component {
  state = {
    expanded: false,
  };

  toggleExpand = () => {
    this.setState((prev) => ({ expanded: !prev.expanded }));
  };

  render() {
    const { expanded } = this.state;

    return (
      <CardWrapper expanded={expanded}>
        <div style={{ minWidth: '341px', padding: '20px' }}>
          <IconHeader>
            <Icon
              name="money bill alternate"
              color="orange"
              size="large"
              style={{ margin: 0 }}
            />
          </IconHeader>

          <CardTitle>Saving for Retirement (RRSP)</CardTitle>
          <CardSubtitle>Build wealth for your golden years.</CardSubtitle>

          <ShowToggle onClick={this.toggleExpand}>
            {expanded ? (
              <React.Fragment>
                Show Less <Icon name="angle up" />
              </React.Fragment>
            ) : (
              <React.Fragment>
                Learn More <Icon name="angle down" />
              </React.Fragment>
            )}
          </ShowToggle>
        </div>
        <CollapsibleSection expanded={expanded}>
          <div>
            <Divider />
            <div
              style={{
                height: '150.5px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <SectionTitle style={{ textAlign: 'center' }}>
                Retirement Planning Target
              </SectionTitle>
              <Value style={{ textAlign: 'center' }}>$500K to $1M+</Value>
              <SubText>
                How much you need for retirement varies based on desired
                lifestyle and goals. Try different scenarios below, find what
                works for you, and start your monthly contributions.
              </SubText>
            </div>

            <Divider />

            <SectionLabel>RRSP Maximum 2026:</SectionLabel>
            <SubText>
              The contribution limit is 18% of your earned income, up to the
              annual maximum of $33,810. This limit could be lower if you have
              an employer pension plan, or higher if you have unused room from
              previous years. Check your Notice of Assessment from the CRA.
            </SubText>
          </div>
        </CollapsibleSection>
      </CardWrapper>
    );
  }
}

export default RetirementCard;

const CardWrapper = styled.div`
  background: white;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
  width: 100%;
  max-width: 473px;
  margin: 0.5rem;
  overflow: hidden;
  max-height: ${(props) => (props.expanded ? '665px' : '214px')};
  transition: max-height 0.4s ease-in-out;
`;

const IconHeader = styled.div`
  background: #ffe7d6;
  border-radius: 50%;
  display: inline-block;
  padding: 0.75rem;
  margin-bottom: 1rem;
`;

const CardTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
`;

const CardSubtitle = styled.p`
  color: #555;
  margin-bottom: 1rem;
`;

const ShowToggle = styled.button`
  background: none;
  border: none;
  color: ${colors.blue};
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 0.5rem;

  &:hover {
    text-decoration: underline;
  }
  i {
    text-decoration: none !important;
  }
`;

const CollapsibleSection = styled.div`
  padding: ${(props) => (props.expanded ? '0 20px 20px' : '0 20px')};
  overflow: hidden;
  text-align: left;
  max-height: ${(props) => (props.expanded ? '700px' : '0')};
  opacity: ${(props) => (props.expanded ? 1 : 0)};
  pointer-events: ${(props) => (props.expanded ? 'auto' : 'none')};
  transition: max-height 0.4s ease, opacity 0.4s ease, padding 0.4s ease-in-out;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #ddd;
`;

const SectionTitle = styled(Header)`
  &&& {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.25rem;
  }
`;

const SectionLabel = styled.p`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 0.25rem;
`;

const SubText = styled.p`
  color: #555;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
`;

const Value = styled.p`
  color: ${colors.blue};
  font-size: 1.17rem;
  padding-top: 0.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
`;
